<template>
  <div class="full_box mobile-i18n-page">
    <custom-tabs
      activeTab="tprFollow"
      :tabs="tabs"
      :hasBack="false"
      color="#ffffff"
      pb="18px"
      class="tpr_tabs"
    >
    </custom-tabs>

    <!-- 搜索框 -->
    <div class="search_box">
      <!-- 请输入搜索关键词 -->
      <van-search
        v-model="searchKeyword"
        :placeholder="$t('mobile.category.searchPlaceholder')"
        shape="round"
        @search="onSearch"
        @clear="onSearch"
        @input="onSearch"
      />
    </div>

    <div class="follow_box">
      <div class="same follow_new">
        <div class="title">
          <!-- 新的抢单信息 -->
          <div class="title_left" v-if="hasNewClue">
            {{ $t("workflowFeedback.newClaimInformation") }}
          </div>
          <!-- 暂无可抢单信息 -->
          <div class="title_no_left" v-else>
            {{ $t("workflowFeedback.noClaimInformation") }}
          </div>
          <!-- 去接单 -->
          <div
            class="title_right"
            @click="$router.push('/follow/pendingFollow')"
          >
            {{ $t("mobile.home.acceptOrder") }}
            <van-icon name="arrow" />
          </div>
        </div>
      </div>

      <div v-if="preOrderList && preOrderList.length > 0" class="follow_list">
        <TPRFollowListItem
          v-for="item in preOrderList"
          :key="item.id"
          :item="item"
          class="same"
        ></TPRFollowListItem>
      </div>
      <div v-else>
        <!-- 暂无数据 -->
        <van-empty :description="$t('business.noData')" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomTabs from "@/components/CustomTabs.vue";
import CountBox from "@/components/CountBox.vue";
import TPRFollowListItem from "@/components/TPRFollowListItem.vue";
import { getUserInfoDetail } from "@/api/user";
import { getMyFollowList } from "@/api/MyFollow";
import { listPendingClue } from "@/api/bizOppor";

export default {
  name: "TPR",
  components: {
    TPRFollowListItem,
    CountBox,
    CustomTabs,
  },
  data() {
    return {
      //状态1已提交2谈判人已接单3商务已接单4已生成合同5已确认金额6买家已支付7货主已支付9交易完成

      active: 0,
      params: {
        pageSize: 10,
        pageNum: 1,
        status: null,
      },
      isEdit: false,
      userInfo: {
        businessType: null,
      },
      searchKeyword: "", // 搜索关键词
      originalPreOrderList: [], // 保存原始列表数据
      preOrderList: [], // 展示的列表数据（可能经过过滤）
      preOrderTotal: 0,

      clueFollowList: [],
      clueFollowTotal: 0,
      preOrderFollowList: [],
      preOrderFollowTotal: 0,
      hasNewClue: false, //是否有新订单
    };
  },
  computed: {
    tabList() {
      return [
        // 全部
        { title: this.$t("business.all"), status: null, name: "all" },
        // { title: "待处理", status: 3, name: "wait" },
        // { title: "交易中", status: 4, name: "jy" },
        // { title: "待支付", status: 5, name: "zf" },
        // { title: "交易完成", status: 9, name: "wc" },
      ];
    },
    tabs() {
      return [{ title: "谈判跟单", name: "tprFollow" }];
    },
    // 是否有数据
    hasData() {
      return this.preOrderList && this.preOrderList.length > 0;
    },
  },

  created() {
    this.getUserInfo();
    this.getPendingClueList();
  },
  methods: {
    // 查看是否有新订单
    async getPendingClueList() {
      listPendingClue().then((resp) => {
        this.hasNewClue = resp.rows.length > 0;
      });
    },
    onTab(index) {
      this.active = index;
      this.params.status = this.tabList[index].status;
      this.getMySwFollowPreOrderList();
    },
    async getUserInfo() {
      const response = await getUserInfoDetail();
      console.log("========返回userinfo======", response);
      if (response.code === 200) {
        this.userInfo = response.data.userInfo;
        this.getMySwFollowPreOrderList();
      }
    },
    async getMySwFollowPreOrderList() {
      getMyFollowList(this.params).then((resp) => {
        console.log("=========返回的列表===========", resp.rows);
        this.originalPreOrderList = resp.rows;
        this.preOrderList = resp.rows;
        this.preOrderTotal = resp.total;
        // 如果有搜索关键词，重新过滤
        if (this.searchKeyword) {
          this.onSearch();
        }
      });
    },

    // 搜索方法
    onSearch() {
      if (!this.searchKeyword) {
        // 如果搜索关键词为空，显示全部数据
        this.preOrderList = this.originalPreOrderList;
        return;
      }

      const keyword = this.searchKeyword.toLowerCase();
      // 过滤列表数据
      this.preOrderList = this.originalPreOrderList.filter((item) => {
        // 根据实际数据结构调整搜索字段
        return (
          (item.goodsName && item.goodsName.toLowerCase().includes(keyword)) ||
          (item.sellerName &&
            item.sellerName.toLowerCase().includes(keyword)) ||
          (item.buyerName && item.buyerName.toLowerCase().includes(keyword)) ||
          (item.orderNo && item.orderNo.toLowerCase().includes(keyword))
        );
      });
    },
    viewDetail(item) {
      console.log("=======查看详情============", item);
      this.$router.push("/preOrderDetail/" + item.id);
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
// 主题 padding
.full_box {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  .tpr_tabs {
  }

  .search_box {
    padding: 8px 12px 0;
    background-color: #fff;
  }

  .follow_box {
    margin: 8px 12px 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    overflow-y: scroll;
    padding-bottom: @bottom-bar-height;

    .same {
      padding: 15px 12px 18px;
      background-color: #fff;
      border-radius: 12px;
    }

    .follow_new {
      display: flex;
      flex-direction: column;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title_left,
        .title_no_left {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #3b3b3b;
          font-size: 16px;
        }

        .title_left::before {
          content: ""; //必须设置content为空，否则伪元素不显示
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #f95348;
        }
        .title_right {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #4286f5;
          font-size: 16px;
        }
      }
    }

    .follow_list {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .follow_item {
      }
    }
  }
}
</style>
